<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17E1LJv/tc-custom/9780374715960.jpg?1737195674959" alt="This image is the cover for the book Mighty Franks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mighty Franks
      </h1>
      <p class="bookDescription body article font2">
        <p><b>WINNER OF THE 2018 JG-WINGATE PRIZE </b><br/><b><br/>A psychologically acute memoir about an unusual Hollywood family by Michael Frank, who "brings Proustian acuity and razor-sharp prose to family dramas as primal, and eccentrically insular, as they come" (<i>The Atlantic)</i><br/></b><br/>“My feeling for Mike is something out of the ordi - nary,” Michael Frank overhears his aunt telling his mother when he is a boy of eight. “It’s stronger than I am. I cannot explain it . . . I love him beyond life itself.” With this indelible bit of eavesdropping, we fall into the spellbinding world of <i>The Mighty Franks</i>. <br/><br/>The family is uncommonly close: Michael’s childless Auntie Hankie and Uncle Irving, glamorous Hollywood screenwriters, are doubly related— Hankie is his father’s sister, and Irving is his mother’s brother. The two families live near each other in Laurel Canyon. In this strangely intertwined world, even the author’s grandmothers—who dislike each other—share a nearby apartment. <br/><br/>Strangest of all is the way Auntie Hankie, with her extravagant personality, comes to bend the wider family to her will. Talented, mercurial, and lavish with her love, she divides Michael from his parents and his two younger brothers as she takes charge of his education, guiding him to the right books to read (Proust, not Zola), the right painters to admire (Matisse, not Pollock), the right architectural styles to embrace (period, not modern—or <i>mo-derne</i>, as she pronounces the word, with palpable disdain). She trains his mind and his eye—until that eye begins to see on its own. When this “son” Hankie longs for grows up and begins to turn away from her, her moods darken, and a series of shattering scenes compel Michael to reconstruct both himself and his family narrative as he tries to reconcile the woman he once adored with the troubled figure he discovers her to be. <br/><br/>In its portrayal of this fascinating, singularly polarizing figure, the boy in her thrall, and the man that boy becomes, <i>The Mighty Franks</i> will speak to any reader who has ever struggled to find an independent voice amid the turbulence of family life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Frank
      </h2>
      
      <p class="authorDescription body article"><B>Michael Frank</B>’s essays, articles, and short stories have appeared in <I>The New York Times</I><I>, The Wall Street Journal, The Atlantic, Slate, </I><I>The Yale Review, Salmagundi, </I>and <I>Tablet</I>, among other publications. His fiction has been presented at Symphony Space’s <I>Selected Shorts: A Celebration of the Short Story</I>, and his travel writing has been collected in <I>Italy: The Best Travel Writing from The New York Times</I>. He served as a Contributing Writer to the <I>Los Angeles Times Book Review</I> for nearly ten years.  He lives with his family in New York City and Liguria, Italy.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f458c12